import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Flag06 = function Flag06(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M4 21V4m0 9h7.4c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C13 12.2401 13 11.9601 13 11.4V4.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C12.2401 3 11.9601 3 11.4 3H5.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C4 3.76 4 4.04 4 4.6zm9-8h6.4c.5601 0 .8401 0 1.054.109a1 1 0 0 1 .437.437C21 5.76 21 6.04 21 6.6v6.8c0 .5601 0 .8401-.109 1.054a1 1 0 0 1-.437.437C20.2401 15 19.9601 15 19.4 15h-4.8c-.5601 0-.8401 0-1.054-.109a1 1 0 0 1-.437-.437C13 14.2401 13 13.9601 13 13.4z"
    })
  }));
};
export default Flag06;